import { obtenerProductosCompuesto } from "../infraestructure/supabase/vistaproductoCompuesto.repository.js";

export async function obtenerProductosCompuestosUseCase() {
  console.log("[UseCase] Ejecutando obtenerProductosCompuesto...");

  const resultado = await obtenerProductosCompuesto();

  console.log("[UseCase] Tipo de resultado:", typeof resultado);
  console.log("[UseCase] Es array:", Array.isArray(resultado));
  console.log("[UseCase] Total registros:", resultado?.length);

  if (!Array.isArray(resultado)) {
    console.error("[UseCase] Formato inesperado:", resultado);
    throw new Error("Formato inesperado en obtenerProductosCompuesto");
  }

  if (resultado.length === 0) {
    console.warn("[UseCase] El array viene vacío");
    return [];
  }

  const primerProducto = resultado[0];

  console.log("----- ANALISIS PRODUCTO -----");
  console.log("Claves producto:", Object.keys(primerProducto));
  console.log("Producto completo:", JSON.stringify(primerProducto, null, 2));

  if (primerProducto.productos_bom) {
    console.log("productos_bom existe");
    console.log("Es array:", Array.isArray(primerProducto.productos_bom));
    console.log("Cantidad BOM:", primerProducto.productos_bom?.length);

    if (primerProducto.productos_bom.length > 0) {
      const primerBom = primerProducto.productos_bom[0];

      console.log("----- ANALISIS BOM -----");
      console.log("Claves BOM:", Object.keys(primerBom));
      console.log("BOM completo:", JSON.stringify(primerBom, null, 2));
    }
  } else {
    console.warn("El producto no tiene propiedad productos_bom");
  }

  return resultado;
}